__turbopack_context__.v({
  "ant-dropdown-menu": "index-module-scss-module__sD0yoG__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__sD0yoG__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__sD0yoG__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__sD0yoG__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__sD0yoG__back-top-wrap",
  "emptyYet": "index-module-scss-module__sD0yoG__emptyYet",
  "filterTableSelect": "index-module-scss-module__sD0yoG__filterTableSelect",
});
